// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fMD-i","question":"styles_question__3ZHCh","description":"styles_description__1hmYO"};